// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#transaction-container {
  height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
}
#transaction-container .project-search-block {
  position: relative;
}
#transaction-container .project-search-block .s-icon-block {
  height: 20px;
  display: flex;
  position: absolute;
  left: 14px;
  top: 14px;
}
#transaction-container .project-search-block input {
  height: 47px;
  padding: 0px 0px 0px 40px;
  border: unset;
  width: 300px;
  background-color: var(--ffff);
  font-size: 14px;
  font-family: "f-400";
}
#transaction-container .table-block {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  border: 1px solid #eaedf0;
  background-color: var(--ffff);
}
#transaction-container .table-block .w5 {
  width: 5%;
}
#transaction-container .table-block .w10 {
  width: 10%;
}
#transaction-container .table-block .w20 {
  width: 20%;
}
#transaction-container .table-block .w25 {
  width: 25%;
}
#transaction-container .table-block .w30 {
  width: 30%;
}
#transaction-container .table-block .w35 {
  width: 35%;
}
#transaction-container .table-block .header-block {
  width: 100%;
  display: flex;
  padding: 20.5px 0px 16.5px 0px;
  border-bottom: 1px solid #eaedf0;
}
#transaction-container .table-block .header-block .header-option {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  font-family: "f-400";
  color: var(--7e91);
}
#transaction-container .table-block .body-block {
  flex-grow: 1;
  height: calc(100vh - 460px);
  overflow: auto;
}
#transaction-container .table-block .body-block .row-block {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 16.5px 0px;
}
#transaction-container .table-block .body-block .row-block .row-cell {
  font-size: 15px;
  font-weight: 500;
  font-family: "f-500";
  color: var(--2749);
}
#transaction-container .table-block .body-block .row-block:nth-child(even) {
  background-color: #fafafa;
}
#transaction-container .table-block .body-block .row-block:hover {
  background-color: rgba(108, 86, 255, 0.1019607843);
  cursor: pointer;
}
#transaction-container .table-block .footer-block {
  border-top: 1px solid #eaedf0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16.5px 25px 16.5px 15px;
}
#transaction-container .table-block .footer-block .page-btn {
  cursor: pointer;
  border: 1px solid #eaedf0;
  background-color: var(--ffff);
  color: var(--2749);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  width: 30px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 400;
  font-family: "f-400";
  -webkit-user-select: none;
          user-select: none;
}
#transaction-container .table-block .footer-block .active-page-btn {
  border: 1px solid var(--56ff);
  background-color: var(--56ff);
  color: var(--ffff);
}
#transaction-container .table-block .footer-block .icon-btn {
  cursor: pointer;
  border: 1px solid var(--dee3);
  background-color: var(--dee3);
  display: flex;
  align-items: center;
  height: 30px;
  width: 30px;
  border-radius: 4px;
  -webkit-user-select: none;
          user-select: none;
}
#transaction-container .table-block .footer-block .icon-btn img {
  height: 20px;
}
#transaction-container .table-block .footer-block .active-icon-btn {
  border: 1px solid var(--56ff);
  background-color: var(--56ff);
  color: var(--ffff);
}
#transaction-container .table-block-dark {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  border: 1px solid var(--102a);
  background-color: var(--102a);
}
#transaction-container .table-block-dark .w5 {
  width: 5%;
}
#transaction-container .table-block-dark .w10 {
  width: 10%;
}
#transaction-container .table-block-dark .w20 {
  width: 20%;
}
#transaction-container .table-block-dark .w25 {
  width: 25%;
}
#transaction-container .table-block-dark .w30 {
  width: 30%;
}
#transaction-container .table-block-dark .w35 {
  width: 35%;
}
#transaction-container .table-block-dark .header-block {
  width: 100%;
  display: flex;
  padding: 16.5px 0px;
  border-bottom: 1px solid var(--4d6c);
  background: var(--2b4e);
}
#transaction-container .table-block-dark .header-block .header-option {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  font-family: "f-400";
  color: var(--c9c9);
}
#transaction-container .table-block-dark .body-block {
  flex-grow: 1;
  height: calc(100vh - 460px);
  overflow: auto;
}
#transaction-container .table-block-dark .body-block .row-block {
  width: 100%;
  display: flex;
  padding: 16.5px 0px;
}
#transaction-container .table-block-dark .body-block .row-block .row-cell {
  font-size: 16px;
  font-weight: 400;
  font-family: "f-400";
  color: var(--ffff);
}
#transaction-container .table-block-dark .body-block .row-block:nth-child(even) {
  background: rgba(40, 43, 78, 0.3019607843);
}
#transaction-container .table-block-dark .body-block .row-block:hover {
  background-color: var(--2b4e);
  cursor: pointer;
}
#transaction-container .table-block-dark .footer-block {
  border-top: 1px solid var(--4d6c);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16.5px 25px 16.5px 15px;
  background: var(--2b4e);
}
#transaction-container .table-block-dark .footer-block .page-btn {
  cursor: pointer;
  border: 1px solid var(--4d6c);
  background-color: var(--4d6c);
  color: var(--ffff);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  width: 30px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 400;
  font-family: "f-400";
  -webkit-user-select: none;
          user-select: none;
}
#transaction-container .table-block-dark .footer-block .active-page-btn {
  border: 1px solid var(--56ff);
  background-color: var(--56ff);
  color: var(--ffff);
}
#transaction-container .table-block-dark .footer-block .icon-btn {
  cursor: pointer;
  border: 1px solid var(--4d6c);
  background-color: var(--4d6c);
  display: flex;
  align-items: center;
  height: 30px;
  width: 30px;
  border-radius: 4px;
  -webkit-user-select: none;
          user-select: none;
}
#transaction-container .table-block-dark .footer-block .icon-btn img {
  height: 20px;
}
#transaction-container .table-block-dark .footer-block .active-icon-btn {
  border: 1px solid var(--56ff);
  background-color: var(--56ff);
  color: var(--ffff);
}
#transaction-container .dropdownStyle #dropdown-basic {
  background-color: var(--4d6c);
  border: unset;
  padding: unset;
  margin: unset;
}
#transaction-container .dropdownStyle .dropdown-toggle::after {
  display: none;
}
#transaction-container .dropdownStyle .dropdown-menu {
  min-width: 50px !important;
  margin-top: 10px;
}
#transaction-container .dropdownStyle .dropdown-menu.show {
  background-color: var(--4d6c);
  color: var(--ffff);
  --bs-dropdown-link-hover-bg: var(--2b4e);
}
#transaction-container .dropdownStyle .dropdown-item:active {
  background-color: var(--56ff);
  color: var(--ffff) !important;
}
#transaction-container #dropdown-basic {
  background-color: unset;
  border: unset;
  padding: unset;
  margin: unset;
}
#transaction-container .dropdown-toggle::after {
  display: none;
}
#transaction-container .dropdown-menu {
  min-width: 50px !important;
  margin-top: 10px;
}
#transaction-container .dropdown-item:active {
  background-color: var(--56ff);
  color: var(--ffff) !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Transaction/Transaction.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,aAAA;EACA,sBAAA;AACF;AAAE;EACE,kBAAA;AAEJ;AADI;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AAGN;AADI;EACE,YAAA;EACA,yBAAA;EACA,aAAA;EACA,YAAA;EACA,6BAAA;EACA,eAAA;EACA,oBAAA;AAGN;AAAE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;AAEJ;AAAI;EACE,SAAA;AAEN;AAAI;EACE,UAAA;AAEN;AAAI;EACE,UAAA;AAEN;AAAI;EACE,UAAA;AAEN;AAAI;EACE,UAAA;AAEN;AAAI;EACE,UAAA;AAEN;AAAI;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,gCAAA;AAEN;AADM;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;AAGR;AAAI;EACE,YAAA;EACA,2BAAA;EACA,cAAA;AAEN;AAAM;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAER;AADQ;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;AAGV;AADQ;EACE,yBAAA;AAGV;AADQ;EACE,kDAAA;EACA,eAAA;AAGV;AACI;EACE,6BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gCAAA;AACN;AAAM;EACE,eAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,yBAAA;UAAA,iBAAA;AAER;AAAM;EACE,6BAAA;EACA,6BAAA;EACA,kBAAA;AAER;AAAM;EACE,eAAA;EACA,6BAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;AAER;AADQ;EACE,YAAA;AAGV;AAAM;EACE,6BAAA;EACA,6BAAA;EACA,kBAAA;AAER;AAEE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,6BAAA;AAAJ;AACI;EACE,SAAA;AACN;AACI;EACE,UAAA;AACN;AACI;EACE,UAAA;AACN;AACI;EACE,UAAA;AACN;AACI;EACE,UAAA;AACN;AACI;EACE,UAAA;AACN;AACI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,oCAAA;EACA,uBAAA;AACN;AAAM;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;AAER;AACI;EACE,YAAA;EACA,2BAAA;EACA,cAAA;AACN;AAAM;EACE,WAAA;EACA,aAAA;EACA,mBAAA;AAER;AADQ;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;AAGV;AADQ;EACE,0CAAA;AAGV;AADQ;EACE,6BAAA;EACA,eAAA;AAGV;AACI;EACE,iCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gCAAA;EACA,uBAAA;AACN;AAAM;EACE,eAAA;EACA,6BAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,yBAAA;UAAA,iBAAA;AAER;AAAM;EACE,6BAAA;EACA,6BAAA;EACA,kBAAA;AAER;AAAM;EACE,eAAA;EACA,6BAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;AAER;AADQ;EACE,YAAA;AAGV;AAAM;EACE,6BAAA;EACA,6BAAA;EACA,kBAAA;AAER;AAGI;EACE,6BAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;AADN;AAGI;EACE,aAAA;AADN;AAGI;EACE,0BAAA;EACA,gBAAA;AADN;AAGI;EACE,6BAAA;EACA,kBAAA;EACA,wCAAA;AADN;AAGI;EACE,6BAAA;EACA,6BAAA;AADN;AAIE;EACE,uBAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;AAFJ;AAIE;EACE,aAAA;AAFJ;AAIE;EACE,0BAAA;EACA,gBAAA;AAFJ;AAIE;EACE,6BAAA;EACA,6BAAA;AAFJ","sourcesContent":["#transaction-container {\r\n  height: calc(100vh - 80px);\r\n  display: flex;\r\n  flex-direction: column;\r\n  .project-search-block {\r\n    position: relative;\r\n    .s-icon-block {\r\n      height: 20px;\r\n      display: flex;\r\n      position: absolute;\r\n      left: 14px;\r\n      top: 14px;\r\n    }\r\n    input {\r\n      height: 47px;\r\n      padding: 0px 0px 0px 40px;\r\n      border: unset;\r\n      width: 300px;\r\n      background-color: var(--ffff);\r\n      font-size: 14px;\r\n      font-family: \"f-400\";\r\n    }\r\n  }\r\n  .table-block {\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex-grow: 1;\r\n    border: 1px solid #eaedf0;\r\n    background-color: var(--ffff);\r\n\r\n    .w5 {\r\n      width: 5%;\r\n    }\r\n    .w10 {\r\n      width: 10%;\r\n    }\r\n    .w20 {\r\n      width: 20%;\r\n    }\r\n    .w25 {\r\n      width: 25%;\r\n    }\r\n    .w30 {\r\n      width: 30%;\r\n    }\r\n    .w35 {\r\n      width: 35%;\r\n    }\r\n    .header-block {\r\n      width: 100%;\r\n      display: flex;\r\n      padding: 20.5px 0px 16.5px 0px;\r\n      border-bottom: 1px solid #eaedf0;\r\n      .header-option {\r\n        display: flex;\r\n        align-items: center;\r\n        font-size: 14px;\r\n        font-weight: 400;\r\n        font-family: \"f-400\";\r\n        color: var(--7e91);\r\n      }\r\n    }\r\n    .body-block {\r\n      flex-grow: 1;\r\n      height: calc(100vh - 460px);\r\n      overflow: auto;\r\n\r\n      .row-block {\r\n        width: 100%;\r\n        display: flex;\r\n        align-items: center;\r\n        padding: 16.5px 0px;\r\n        .row-cell {\r\n          font-size: 15px;\r\n          font-weight: 500;\r\n          font-family: \"f-500\";\r\n          color: var(--2749);\r\n        }\r\n        &:nth-child(even) {\r\n          background-color: #fafafa;\r\n        }\r\n        &:hover {\r\n          background-color: #6c56ff1a;\r\n          cursor: pointer;\r\n        }\r\n      }\r\n    }\r\n    .footer-block {\r\n      border-top: 1px solid #eaedf0;\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      padding: 16.5px 25px 16.5px 15px;\r\n      .page-btn {\r\n        cursor: pointer;\r\n        border: 1px solid #eaedf0;\r\n        background-color: var(--ffff);\r\n        color: var(--2749);\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        height: 30px;\r\n        width: 30px;\r\n        border-radius: 4px;\r\n        font-size: 14px;\r\n        font-weight: 400;\r\n        font-family: \"f-400\";\r\n        user-select: none;\r\n      }\r\n      .active-page-btn {\r\n        border: 1px solid var(--56ff);\r\n        background-color: var(--56ff);\r\n        color: var(--ffff);\r\n      }\r\n      .icon-btn {\r\n        cursor: pointer;\r\n        border: 1px solid var(--dee3);\r\n        background-color: var(--dee3);\r\n        display: flex;\r\n        align-items: center;\r\n        height: 30px;\r\n        width: 30px;\r\n        border-radius: 4px;\r\n        user-select: none;\r\n        img {\r\n          height: 20px;\r\n        }\r\n      }\r\n      .active-icon-btn {\r\n        border: 1px solid var(--56ff);\r\n        background-color: var(--56ff);\r\n        color: var(--ffff);\r\n      }\r\n    }\r\n  }\r\n  .table-block-dark {\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex-grow: 1;\r\n    border: 1px solid var(--102a);\r\n    background-color: var(--102a);\r\n    .w5 {\r\n      width: 5%;\r\n    }\r\n    .w10 {\r\n      width: 10%;\r\n    }\r\n    .w20 {\r\n      width: 20%;\r\n    }\r\n    .w25 {\r\n      width: 25%;\r\n    }\r\n    .w30 {\r\n      width: 30%;\r\n    }\r\n    .w35 {\r\n      width: 35%;\r\n    }\r\n    .header-block {\r\n      width: 100%;\r\n      display: flex;\r\n      padding: 16.5px 0px;\r\n      border-bottom: 1px solid var(--4d6c);\r\n      background: var(--2b4e);\r\n      .header-option {\r\n        display: flex;\r\n        align-items: center;\r\n        font-size: 14px;\r\n        font-weight: 400;\r\n        font-family: \"f-400\";\r\n        color: var(--c9c9);\r\n      }\r\n    }\r\n    .body-block {\r\n      flex-grow: 1;\r\n      height: calc(100vh - 460px);\r\n      overflow: auto;\r\n      .row-block {\r\n        width: 100%;\r\n        display: flex;\r\n        padding: 16.5px 0px;\r\n        .row-cell {\r\n          font-size: 16px;\r\n          font-weight: 400;\r\n          font-family: \"f-400\";\r\n          color: var(--ffff);\r\n        }\r\n        &:nth-child(even) {\r\n          background: #282b4e4d;\r\n        }\r\n        &:hover {\r\n          background-color: var(--2b4e);\r\n          cursor: pointer;\r\n        }\r\n      }\r\n    }\r\n    .footer-block {\r\n      border-top: 1px solid var(--4d6c);\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      padding: 16.5px 25px 16.5px 15px;\r\n      background: var(--2b4e);\r\n      .page-btn {\r\n        cursor: pointer;\r\n        border: 1px solid var(--4d6c);\r\n        background-color: var(--4d6c);\r\n        color: var(--ffff);\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        height: 30px;\r\n        width: 30px;\r\n        border-radius: 4px;\r\n        font-size: 14px;\r\n        font-weight: 400;\r\n        font-family: \"f-400\";\r\n        user-select: none;\r\n      }\r\n      .active-page-btn {\r\n        border: 1px solid var(--56ff);\r\n        background-color: var(--56ff);\r\n        color: var(--ffff);\r\n      }\r\n      .icon-btn {\r\n        cursor: pointer;\r\n        border: 1px solid var(--4d6c);\r\n        background-color: var(--4d6c);\r\n        display: flex;\r\n        align-items: center;\r\n        height: 30px;\r\n        width: 30px;\r\n        border-radius: 4px;\r\n        user-select: none;\r\n        img {\r\n          height: 20px;\r\n        }\r\n      }\r\n      .active-icon-btn {\r\n        border: 1px solid var(--56ff);\r\n        background-color: var(--56ff);\r\n        color: var(--ffff);\r\n      }\r\n    }\r\n  }\r\n  .dropdownStyle {\r\n    #dropdown-basic {\r\n      background-color: var(--4d6c);\r\n      border: unset;\r\n      padding: unset;\r\n      margin: unset;\r\n    }\r\n    .dropdown-toggle::after {\r\n      display: none;\r\n    }\r\n    .dropdown-menu {\r\n      min-width: 50px !important;\r\n      margin-top: 10px;\r\n    }\r\n    .dropdown-menu.show {\r\n      background-color: var(--4d6c);\r\n      color: var(--ffff);\r\n      --bs-dropdown-link-hover-bg: var(--2b4e);\r\n    }\r\n    .dropdown-item:active {\r\n      background-color: var(--56ff);\r\n      color: var(--ffff) !important;\r\n    }\r\n  }\r\n  #dropdown-basic {\r\n    background-color: unset;\r\n    border: unset;\r\n    padding: unset;\r\n    margin: unset;\r\n  }\r\n  .dropdown-toggle::after {\r\n    display: none;\r\n  }\r\n  .dropdown-menu {\r\n    min-width: 50px !important;\r\n    margin-top: 10px;\r\n  }\r\n  .dropdown-item:active {\r\n    background-color: var(--56ff);\r\n    color: var(--ffff) !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
